<template>
	<div>
		<router-view :key="$route.meta.timestamp" />
	</div>
	<v-dialog v-model="isOutdatedPriceListDialogVisible" max-width="560" persistent>
		<v-card>
			<v-card-title
				class="text-danger d-flex align-items-center justify-content-between">
				Atenție!
				<v-icon color="danger">mdi-alert-octagon-outline</v-icon>
			</v-card-title>
			<v-card-text>
				Oferta folosește o listă de prețuri mai veche decât lista curentă.
				Dorești să salvezi cu ultima listă de preț?
				<div class="mt-3">
					<b>Lista veche:</b> {{ outdatedPriceListDialog.oldLabel }}
				</div>
				<div>
					<b>Lista curentă:</b> {{ outdatedPriceListDialog.newLabel }}
				</div>
			</v-card-text>
			<v-card-actions class="justify-end">
				<v-btn color="secondary" variant="text" @click="chooseOldPriceList">
					NU
				</v-btn>
				<v-btn color="primary" @click="chooseNewPriceList">
					DA
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	<v-dialog v-model="pressRingDialog" max-width="520" persistent>
		<v-card>
			<v-card-title class="text-h6">Inele PRESS</v-card-title>
			<v-card-text v-if="pressRingStep === 'ask'">
				Oferta conține fitinguri PRESS 25/26. Se calculează inelele?
			</v-card-text>
			<v-card-text v-else>
				Alege varianta inelului. Se calculează
				<strong>{{ pressRingTotal }}</strong>
				{{ pressRingTotal === 1 ? "inel" : "inele" }}.
			</v-card-text>
			<v-card-actions class="justify-end">
				<template v-if="pressRingStep === 'ask'">
					<v-btn variant="text" @click="finishPressRingChoice('no')">
						NU
					</v-btn>
					<v-btn color="success" @click="pressRingStep = 'variant'">
						DA
					</v-btn>
				</template>
				<template v-else>
					<v-btn variant="text" @click="pressRingStep = 'ask'">
						Înapoi
					</v-btn>
					<v-btn color="primary" @click="finishPressRingChoice(25)">
						Inel 25
					</v-btn>
					<v-btn color="primary" @click="finishPressRingChoice(26)">
						Inel 26
					</v-btn>
				</template>
			</v-card-actions>
		</v-card>
	</v-dialog>
	<v-dialog v-model="isMaintenanceWarningVisible" max-width="560" persistent>
		<v-card>
			<v-card-title class="text-warning d-flex align-items-center justify-content-between">
				Atenție — Mentenanță
				<v-icon color="warning">mdi-alert</v-icon>
			</v-card-title>
			<v-card-text style="white-space: pre-line;">
				{{ maintenanceWarningMessage }}
			</v-card-text>
			<v-card-actions class="justify-end">
				<v-btn color="primary" @click="isMaintenanceWarningVisible = false">
					Am înțeles
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
	<v-overlay
		v-model="isOverlayDisplayed"
		class="d-flex justify-content-center align-items-center">
		<div class="d-flex flex-column align-items-center">
			<v-progress-circular
				color="primary"
				indeterminate
				:size="100"
				:width="6"></v-progress-circular>
			<div
				v-if="overlayMessage"
				class="mt-4 text-subtitle-1 text-center overlay-status-message">
				{{ overlayMessage }}
			</div>
		</div>
	</v-overlay>
</template>
<script lang="js">
import { mapGetters } from "vuex";
import emitter from "@/utils/emitter";
import { priceListSelectTitle } from "@/utils/utils";

export default {
	name: "App",
	data() {
		return {
			isOverlayDisplayed: false,
			overlayMessage: "",
			isOutdatedPriceListDialogVisible: false,
			isMaintenanceWarningVisible: false,
			pressRingDialog: false,
			pressRingStep: "ask",
			pressRingTotal: 0,
			pressRingOnDone: null,
			maintenanceWarningMessage: "",
			outdatedPriceListDialog: {
				oldLabel: "",
				newLabel: "",
				onChooseOld: null,
				onChooseNew: null,
			},
		};
	},
	methods: {
		formatPriceListLabel(priceList) {
			if (!priceList) return "-";
			const title = priceListSelectTitle(priceList);
			return title.replace(
				/(\d{2})\.(\d{2})\.(\d{4})/g,
				"$1-$2-$3"
			);
		},
		chooseOldPriceList() {
			const callback = this.outdatedPriceListDialog.onChooseOld;
			this.isOutdatedPriceListDialogVisible = false;
			this.outdatedPriceListDialog.onChooseOld = null;
			this.outdatedPriceListDialog.onChooseNew = null;
			if (typeof callback === "function") callback();
		},
		finishPressRingChoice(answer) {
			const callback = this.pressRingOnDone;
			this.pressRingDialog = false;
			this.pressRingStep = "ask";
			this.pressRingOnDone = null;
			if (typeof callback === "function") callback(answer);
		},
		chooseNewPriceList() {
			const callback = this.outdatedPriceListDialog.onChooseNew;
			this.isOutdatedPriceListDialogVisible = false;
			this.outdatedPriceListDialog.onChooseOld = null;
			this.outdatedPriceListDialog.onChooseNew = null;
			if (typeof callback === "function") callback();
		},
	},
	async mounted() {
		this._onTriggerOverlay = () => {
			this.isOverlayDisplayed = !this.isOverlayDisplayed;
			if (!this.isOverlayDisplayed) this.overlayMessage = "";
		};
		this._onShowOverlay = message => {
			this.overlayMessage = message || "";
			this.isOverlayDisplayed = true;
		};
		this._onHideOverlay = () => {
			this.isOverlayDisplayed = false;
			this.overlayMessage = "";
		};
		this._onOutdatedPriceList = payload => {
			this.outdatedPriceListDialog.oldLabel = this.formatPriceListLabel(
				payload?.oldPriceList
			);
			this.outdatedPriceListDialog.newLabel = this.formatPriceListLabel(
				payload?.newPriceList
			);
			this.outdatedPriceListDialog.onChooseOld = payload?.onChooseOld || null;
			this.outdatedPriceListDialog.onChooseNew = payload?.onChooseNew || null;
			this.isOutdatedPriceListDialogVisible = true;
		};
		this._onMaintenanceWarning = payload => {
			this.maintenanceWarningMessage =
				payload?.message ||
				"Atenție: în curând se vor efectua lucrări de mentenanță.\n\n" +
					"Vă rugăm să salvați toate lucrările în curs. Datele nesalvate se vor pierde.\n\n" +
					"Pe durata mentenanței nu vă veți putea conecta. După finalizare va trebui să vă autentificați din nou.";
			this.isMaintenanceWarningVisible = true;
		};
		emitter.on("trigger-overlay", this._onTriggerOverlay);
		emitter.on("show-overlay", this._onShowOverlay);
		emitter.on("hide-overlay", this._onHideOverlay);
		this._onAskPressRings = payload => {
			this.pressRingTotal = Number(payload?.total) || 0;
			this.pressRingStep = "ask";
			this.pressRingOnDone = payload?.onDone || null;
			this.pressRingDialog = true;
		};
		emitter.on("show-outdated-pricelist-dialog", this._onOutdatedPriceList);
		emitter.on("ask-press-rings", this._onAskPressRings);
		emitter.on("maintenance-warning", this._onMaintenanceWarning);
	},
	unmounted() {
		emitter.off("trigger-overlay", this._onTriggerOverlay);
		emitter.off("show-overlay", this._onShowOverlay);
		emitter.off("hide-overlay", this._onHideOverlay);
		emitter.off("show-outdated-pricelist-dialog", this._onOutdatedPriceList);
		emitter.off("ask-press-rings", this._onAskPressRings);
		emitter.off("maintenance-warning", this._onMaintenanceWarning);
	},
	computed: {
		...mapGetters(["userPermissions"]),
	},
};
</script>
<style>
#app {
	--bs-bg-opacity: 1;
	background-color: rgba(
		var(--bs-light-rgb),
		var(--bs-bg-opacity)
	) !important;
}

.v-container {
	max-width: 100% !important;
}

.overlay-status-message {
	color: #fff;
	background: rgba(0, 0, 0, 0.55);
	padding: 8px 14px;
	border-radius: 8px;
	font-weight: 600;
	letter-spacing: 0.2px;
}
</style>
